import { PropsWithChildren, useState } from "react";
import { RouteDialog } from "../RouteDialog";
import { routeDialogs } from "../routeDialogs";
import { RouteDialogsContext } from "./RouteDialogsContext";

type RouteDialogsProviderProps = PropsWithChildren;

export function RouteDialogsProvider({ children }: RouteDialogsProviderProps) {
  const [trigger, setTrigger] =
    useState<React.RefObject<HTMLAnchorElement | null> | null>(null);

  return (
    <RouteDialogsContext.Provider value={{ setTrigger, trigger }}>
      {children}
      {routeDialogs.map((dialog) => (
        <RouteDialog {...dialog} key={dialog.path} />
      ))}
    </RouteDialogsContext.Provider>
  );
}
